export const initialValues = {
  name: "",
  rfc: "XAXX010101000",
  isWholesaler: "",
  phone: "",
  searchAddress: "",
  street: "",
  extNumber: "",
  intNumber: "",
  colony: "",
  municipality: "",
  postalCode: "",
  state: "",
  reference: "",
  idStation: null,
  type: null,
  segment: null,
  segmentsOpt: [],
  subsegment: null,
  factor: null,
  isVerified: false,
};

export const fieldValidations = (isNew = false) => {
  const validations = {
    name: {
      required: true,
    },
    rfc: {
      exactLength: 13,
      message: "RFC debe tener una longitud de 13 caracteres",
      required: isNew,
    },
    phone: {
      exactLength: 10,
      message: "Telefono debe tener una longitud de 10 digitos",
      required: true,
    },
    idStation: {
      required: true,
    },
    type: {
      required: true,
    },
    segment: {
      required: true,
    },
    subsegment: {
      required: true,
    },
    street: {
      required: true,
    },
    extNumber: {
      required: true,
    },
    colony: {
      required: true,
    },
    municipality: {
      required: true,
    },
    postalCode: {
      required: true,
    },
    state: {
      required: true,
    },
  };

  return validations
}

export const isWholesalerOptions = [
  {
    label: "Mayorista",
    value: 1
  },
  {
    label: "Casa",
    value: 0
  }
]